import { WebIcons } from "@/config/antd";

export const SEARCH_CONFIG = {
  campaigns: {
    label: "Campaigns",
    icon: WebIcons.CampaignHover,
    route: (id) => `/dashboard/events/${id}`,
    getPrimaryText: (item) => item.position || "Campaign",
    getSecondaryText: (item) => item.name,
  },

  "sub-events": {
    label: "Sub Events",
    icon: WebIcons.CampaignHover,
    //
    //
    route: (id) => `/dashboard/events/${id}`,

    routeFromItem: (item) => {
      const subEventId = item?.id || item?._id;
      const eventId =
        item?.eventID?._id ||
        item?.eventID ||
        item?.eventId?._id ||
        item?.eventId;

      if (!eventId || !subEventId) return null;
      return `/dashboard/events/${eventId}/schedule/${subEventId}`;
    },
    getPrimaryText: (item) => item.label || "Sub Event",
    getSecondaryText: (item) => item.description || "",
  },

  media: {
    label: "Media",
    icon: WebIcons.MediaHover,
    route: (id) => `/dashboard/media?mediaId=${encodeURIComponent(id)}`,
    getPrimaryText: (item) => item.name,
    getSecondaryText: (item) => item.description,
    getThumbnailUrl: (item) =>
      Array.isArray(item.imageFiles) && item.imageFiles.length > 0
        ? item.imageFiles[0]
        : null,
  },

  "support-tickets": {
    label: "Support Tickets",
    icon: WebIcons.SupportHover,
    route: (id) => `/dashboard/settings/support/${id}`,
    getPrimaryText: (item) => item.subject,
    getSecondaryText: (item) => item.description,
    getBadges: (item) => {
      const statusColor =
        item.status === "Closed"
          ? "red"
          : item.status === "Open"
          ? "green"
          : "blue";

      const priorityColor =
        item.priority === "High"
          ? "red"
          : item.priority === "Medium"
          ? "orange"
          : "default";

      const badges = [];

      if (item.status) {
        badges.push({
          key: `status-${item.status}`,
          color: statusColor,
          label: item.status,
        });
      }

      if (item.priority) {
        badges.push({
          key: `priority-${item.priority}`,
          color: priorityColor,
          label: item.priority,
        });
      }

      return badges;
    },
  },

  financial: {
    label: "Finance",
    icon: WebIcons.FinancialHover,
    route: (id) => `/dashboard/financial/transaction/${id}`,
    getPrimaryText: (item) => item.title || item.name || "Transaction",
    getSecondaryText: (item) => item.description || item.category || "",
  },

  finance: {
    label: "Finance",
    icon: WebIcons.FinancialHover,
    route: (id) => `/dashboard/financial/transaction/${id}`,
    getPrimaryText: (item) => item.title || item.name || "Transaction",
    getSecondaryText: (item) => item.description || item.category || "",
  },

  canvass: {
    label: "Canvass",
    icon: WebIcons.CanvassHover,
    route: (id) => `/dashboard/canvass/${id}`,
    getPrimaryText: (item) => item.name || item.title || "Canvass",
    getSecondaryText: (item) => item.description || "",
  },

  townhall: {
    label: "Town Hall",
    icon: WebIcons.TownHallHover,
    route: (id) => `/dashboard/townhall/${id}`,
    getPrimaryText: (item) => item.name || item.title || "Town Hall",
    getSecondaryText: (item) => item.location || item.description || "",
  },

  manifesto: {
    label: "Manifesto",
    icon: WebIcons.ManifestoHover,
    route: (id) => `/dashboard/manifesto/${id}`,
    getPrimaryText: (item) => item.title || item.name || "Manifesto",
    getSecondaryText: (item) => item.description || "",
  },

  polls: {
    label: "Polls & Survey",
    icon: WebIcons.PollsHover,
    route: (id) => `/dashboard/polls/${id}`,
    getPrimaryText: (item) => item.title || item.name || "Poll",
    getSecondaryText: (item) => item.description || "",
  },

  candidates: {
    label: "Candidates",
    icon: WebIcons.CandidatesHover,
    route: (id) => `/dashboard/candidates/${id}`,
    getPrimaryText: (item) => item.fullname || item.name || "Candidate",
    getSecondaryText: (item) => item.position || item.party || "",
  },

  users: {
    label: "Users",
    icon: WebIcons.UserHover,
    route: (id) => `/dashboard/users/${id}`,
    getPrimaryText: (item) => item.fullname || item.name || item.email,
    getSecondaryText: (item) => item.role || item.email || "",
    getAvatarUrl: (item) => item.profileImage || null,
    getAvatarProps: (item) => ({
      src: item.profileImage || null,
      fallback:
        item.fullname?.[0] || item.name?.[0] || item.email?.[0] || "U",
    }),
  },

  roles: {
    label: "Roles",
    icon: WebIcons.RoleHover,
    route: (id) => `/dashboard/roles/${id}`,
    getPrimaryText: (item) => item.name || "Role",
    getSecondaryText: (item) => item.description || "",
  },

  notifications: {
    label: "Notifications",
    icon: WebIcons.NotificationBing,
    route: (id) => `/dashboard/notifications/${id}`,
    getPrimaryText: (item) => item.title || item.message || "Notification",
    getSecondaryText: (item) => item.type || "",
  },

  profiles: {
    label: "Profiles",
    icon: WebIcons.UserHover,
    route: (id) => `/dashboard/users/${id}`,
    getPrimaryText: (item) => item.fullname || item.email,
    getSecondaryText: (item) => item.role || item.email,
    getAvatarUrl: (item) => item.profileImage || null,
    getAvatarProps: (item) => ({
      src: item.profileImage || null,
      fallback: item.fullname?.[0] || item.email?.[0] || "U",
    }),
  },
};

export const getSearchConfigForEntity = (entity) => SEARCH_CONFIG[entity];

